<div>
    <div class="card mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">Order Confirmation</h5>
                    <div style="margin-top: 1rem;">
                        <ul class="order_con">
                            <li><span class="bullet"></span>You order request has been placed <span
                                    class="order_bold">successfully!</span> </li>
                            <li><span class="bullet"></span>The document has been shared with all parties and witnesses
                                for e-signing.</li>
                            <li><span class="bullet"></span> You can download the final document from the order details
                                page once notified.</li>
                            <li><span class="bullet"></span>An email confirmation has been sent to <span
                                    class="title_header_0">{{email}}</span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-1 col-sm-1 col-md-1 vertical_style">

                </div>
                <div class="col-lg-5 col-sm-5 col-md-5">
                    <h5 class="card-title title_header_0">Order Details:</h5>
                    <div class="flex_row">
                        <div class="col-3">
                            <span class="form_field"> Order Number :</span>
                        </div>
                        <div class="col-2">
                            <span class="order_con_value"> {{orderDetails.id}}</span>
                        </div>

                    </div>
                    <div class="flex_row">
                        <div class="col-3">
                            <span class="form_field">Service :</span>
                        </div>
                        <div class="col-2">
                            <span class="order_con_value"> {{orderDetails.service}}</span>
                        </div>

                    </div>
                    <div class="flex_row">
                        <div class="col-3">
                            <span class="form_field"> Date :</span>
                        </div>
                        <div class="col-2">
                            <span class="order_con_value"> {{orderDetails.date}}</span>
                        </div>

                    </div>
                    <div class="flex_row">
                        <div class="col-3">
                            <span class="form_field"> Order Status :</span>
                        </div>
                        <div class="col-3 text-left pt-2">
                            <p-timeline [value]="events">
                                <ng-template pTemplate="content" let-event>
                                    <div class="row">
                                        <span class="badge bg-light status_title"> {{event.status}}</span>
                                        <span class="order_con_value">{{event.date}}</span>
                                    </div>

                                </ng-template>
                            </p-timeline>

                        </div>

                    </div>


                </div>
            </div>
        </div>
        <div class="text-right custom_button m-4">
            <a style="font-size: 10px; color: #612E86;" data-bs-toggle="modal"
                data-bs-target="#uploadDocModal" class="btn-link clickable"><p-button label="Upload Document"
                    (click)="gotoTemplatePage()" styleClass="p-button-sm">
                    <i class='icon_color bx bx-upload bx-sm'></i>
                </p-button></a>
            <p-button label="Track Order Status" styleClass="p-button-sm-outline"></p-button>
        </div>

    </div>

</div>

<div #uploadDocModal class="modal fade" id="uploadDocModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Upload Document</h5>
                <button #closeUploadPopupBtn type="button" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close" [hidden]="true"></button>
                    <button type="button" class="btn-close" (click)="cancelUpload()"></button>
            </div>

            <div class="row p-3">
                <div class="col-lg-8 col-sm-8 col-md-8 selFileName">
                    <app-dropdown class="custom-dropdown_1" [options]="selectFile" optionLabel="label"></app-dropdown>
                </div>
                <div class="col-lg-3 col-sm-3 col-md-3 overlay">
                    <input [hidden]="true" type="file" id="upload_file" (change)="onFileChange($event)" accept=".pdf"
                        #fileInput>
                    <button label="Choose File" type="button" (click)="fileInput.click()"
                        class="btn btn-outline-secondary fileUploadStyle"><span
                            *ngIf="!isDocUploaded; else showFileName">Choose File</span>
                        <ng-template #showFileName>{{fileName}}</ng-template>
                    </button>
                </div>

                <div class="col-lg-1 col-sm-1 col-md-1"></div>
            </div>

            <!-- <div class="row p-2 m-2">
                <p class="text_p">Or drop documents here </p>
            </div> -->

            <div class="row mt-4">
                <div class="col-lg-7 col-sm-7 col-md-7"></div>
                <div class="col-lg-2 col-sm-2 col-md-2">
                    <div class="text-right custom_button">
                        <p-button label="Cancel" (click)="cancelUpload()" styleClass="p-button-sm">
                        </p-button>
                    </div>
                </div>
                <div class="col-lg-2 col-sm-2 col-md-2">
                    <div class="text-right custom_button">
                        <p-button label="Upload" (click)="uploadSelFile()" styleClass="p-button-sm-outline">
                        </p-button>
                    </div>
                </div>
            </div>

            <div class="p-2"></div>

        </div>
    </div>
</div>

<div #uploadDocSuccessModalPopup data-bs-toggle="modal" data-bs-target="#uploadSuccessModal">
</div>

<div #uploadSuccessModal class="modal fade" id="uploadSuccessModal" tabindex="-1" aria-labelledby="uploadSuccessModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="text-right p-3">
                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="text-center pb-5">
                <div>
                    <img src="../../../../assets/img/admin-notified.jpg" width="45" class="logo_style_0">
                </div>

                <p class="pop_style">Document uploaded successfully!</p>

                <div>
                    <p>
                        Your document has arrived its destination in one piece.
                    </p>
                </div>

            </div>

        </div>
    </div>
</div>